import React, { useRef, useState } from 'react';

// Styled Components
import {
  Container,
  Content,
  Greeting,
  Description,
  WarningText,
  InfoText,
  PasswordLabel,
  PasswordContainer,
  PasswordInput,
  ShowPasswordButton,
  DeleteButton,
} from './DeleteAccount.styled';

// Components
import DeleteAccountModal from './DeleteAccountModal';

// Icons
import { Iconify } from '../../../../../Xmerald-UI';
import useUserContext from '../../../../../hooks/useUserContext';
import API from '../../../../../utils/api';
import { ErrorMessage } from './DeleteAccountModal.styled';
import { minWait } from '../../../../../utils/timers';
import useAuthContext from '../../../../../hooks/useAuthContext';

const getUserData = (userObject) => {
  if (userObject.user) {
    return userObject.user;
  }

  return userObject;
}

export default function DeleteAccount() {
  const { userData } = useUserContext();
  const authContext = useAuthContext();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const passwordRef = useRef(null);

  const user = getUserData(userData);

  const handleDeleteAccount = () => {
    if (!password.trim()) {
      alert('Por favor ingresa tu contraseña');
      return;
    }

    // Mostrar modal de confirmación
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    setIsLoading(true);
    // Cerrar modal
    setShowModal(false);

    try {
      const response = await minWait(API.deleteAccount({ type: 'regular', password }), 3000);

      if (response.data.error || response.data.success === false) {
        const errorMessage = response.data?.error ?? 'Ocurrió un error al eliminar la cuenta';
        setErrorMessage(errorMessage);

        if (response.data.error.includes('contraseña')) {
          passwordRef.current.focus();
        }
        return;
      }

      // Cuenta eliminada correctamente
      authContext.logout();
      setPassword('');
    } catch (error) {
      console.error('Error al eliminar la cuenta:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (!user) {
    return <div>Cargando...</div>;
  }

  return (
    <>
      <Container>
        <Content>
          <Greeting>¡Hola {user.name?.toLowerCase()}!</Greeting>

          <Description>Lamentamos que quieras borrar tu cuenta.</Description>

          <Description>
            <WarningText>
              Al dar clic en el botón se comenzará a borrar tu cuenta. Este proceso es final y no se
              puede revertir.
            </WarningText>
          </Description>

          <InfoText>En caso de tener entradas pendientes se borrarán.</InfoText>
          <InfoText>Después de 45 días toda tu información será borrada.</InfoText>
          <PasswordLabel>Ingresa tu contraseña actual.</PasswordLabel>

          <PasswordContainer>
            <PasswordInput
              ref={passwordRef}
              type={showPassword ? 'text' : 'password'}
              placeholder="Contraseña"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <ShowPasswordButton onClick={togglePasswordVisibility} className="guardar-picks">
              <Iconify icon={showPassword ? 'eva:eye-off-fill' : 'eva:eye-fill'} />
            </ShowPasswordButton>
          </PasswordContainer>

          {errorMessage && !isLoading && <ErrorMessage>{errorMessage}</ErrorMessage>}

          {isLoading && (
            <InfoText>
              <Iconify icon="svg-spinners:90-ring" /> Eliminando cuenta...
            </InfoText>
          )}

          <DeleteButton
            onClick={handleDeleteAccount}
            disabled={!password.trim() || password.length < 4 || isLoading}
          >
            BORRAR MI CUENTA
          </DeleteButton>
        </Content>
      </Container>

      <DeleteAccountModal
        isOpen={showModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        userName={user.name?.toLowerCase()}
      />
    </>
  );
}
